import { get } from 'lodash'
import { RISK_REPORTS } from 'src/utils/constants/RiskReports'
import formatDate from 'src/utils/commonMethods/formatDate'
import formatToINR from 'src/utils/commonMethods/formatToINR'
import React from 'react'
import { makeStyles } from '@material-ui/core'
import { COLORS } from 'src/utils/Themes/colors'

const PolicyCard = ({ policy }) => {
  const classes = useStyles()
  const iconUrl = get(policy, 'productImage', '')
  const title = get(policy, 'insuranceType', '')
  const expDate = get(policy, 'expiresOn', '')
  const premiumPaid = get(policy, 'premiumAmount.text', 0)

  return (
    <div className={classes.cardItem}>
      <div className={classes.rowFlex}>
        <div className={classes.icon}>
          <img src={iconUrl} alt='title' />
        </div>
        <div className={classes.title}>{title}</div>
      </div>
      <div className={classes.divider} />
      <div className={classes.rowFlex}>
        <div className={`${classes.cardFooter} ${classes.alignLeft}`}>
          {RISK_REPORTS?.EXPIRES_ON}
          <div className={classes.cardFooterText}>
            {expDate ? formatDate(expDate, 'dd-mmm-yyyy') : ''}
          </div>
        </div>
        <div className={`${classes.cardFooter} ${classes.alignRight}`}>
          {RISK_REPORTS?.PREMIUM_PAID}
          <div className={classes.cardFooterText}>
            {formatToINR(premiumPaid)}
          </div>
        </div>
      </div>
    </div>
  )
}

export default PolicyCard

const useStyles = makeStyles({
  cardItem: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    boxSizing: 'border-box',
    margin: '0px 10px 20px',
    width: 210,
    borderRadius: '10px',
    boxShadow:
      '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)',
    border: '1px solid #e5e5e5',
    minHeight: '48px',
    transition: 'box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    '&:hover': {
      borderColor: '#cdcdcd',
      boxShadow:
        'rgb(0 0 0 / 20%) 0px 3px 3px -2px, rgb(0 0 0 / 14%) 0px 3px 4px 0px, rgb(0 0 0 / 12%) 0px 1px 8px 0px',
    },
  },
  rowFlex: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '12px 16px',
    width: '100%',
    boxSizing: 'border-box',
    height: '60px',
  },
  divider: {
    borderBottom: '1px solid #e5e5e5',
    height: '1px',
    width: '100%',
  },
  icon: {
    width: '24px',
    marginRight: '10px',
    flexShrink: 0,
    '& img': {
      maxWidth: '100%',
    },
  },
  title: {
    fontSize: '14px',
    lineHeight: '18px',
    color: COLORS.GREY,
  },
  cardFooter: {
    fontSize: '11px',
    color: '#112F3C99',
    flexGrow: 1,
  },
  cardFooterText: {
    color: COLORS.GREY,
    fontSize: '12px',
    marginTop: '3px',
    letterSpacing: '0.8px',
  },
  alignLeft: {
    textAlign: 'left',
    '@media (max-width: 600px)': {
      textAlign: 'center',
    },
  },
  alignRight: {
    textAlign: 'right',
    '@media (max-width: 600px)': {
      textAlign: 'center',
    },
  },
})
